import{differenceInCalendarWeeks as r}from"./differenceInCalendarWeeks.js";import{lastDayOfMonth as t}from"./lastDayOfMonth.js";import{startOfMonth as o}from"./startOfMonth.js";function e(e,f){return r(t(e),o(e),f)+1}export{e as default,e as getWeeksInMonth};
//# sourceMappingURL=getWeeksInMonth.js.map
